var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.images && _vm.images.length > 1 && !_vm.singular
      ? 'profile-thumbnail profile-thumbnail--multiple'
      : 'profile-thumbnail'
  ]},[(_vm.images)?_c('div',{staticClass:"profile-thumbnail__photo"},[_c('img',{attrs:{"src":_vm.images[0],"alt":""}})]):_vm._e(),(_vm.images && _vm.images.length > 1 && !_vm.singular)?_c('div',{staticClass:"profile-thumbnail__photo"},[_c('img',{attrs:{"src":_vm.images[1],"alt":""}})]):_vm._e(),(_vm.unreaded)?_c('Badge',[_vm._v(_vm._s(_vm.unreaded))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }